/**
 *
 */

import { API_ROOT } from "@partsbadger/utils";

export { API_ROOT };

export const BASE_URL_WS =
    (typeof API_ROOT === "string" ? API_ROOT : "").replace(/^http/, "ws");
